import React, { useState } from "react";
import { AppBar, Box, Tab, Tabs, useTheme } from "@mui/material";
import { Resolution } from "./Resolution/Resolution";
import { SanctionsAndResolutions } from "./SanctionsAndResolutions/SanctionsAndResolutions";
import { useTranslation } from "react-i18next";

export const ActionsAndResolutions = ({
  victims,
  offenders,
  reportDetail,
  reportRender,
  investigationList,
  setActiveTab,
  setIsLoading,
  isLoading,
}) => {
  const theme = useTheme();
  const [t] = useTranslation("report");

  // Default tab select
  const [valueTab, setValueTab] = useState(0);

  // onChange tab event
  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
    // Adjusts scroll to display content
    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }, 500);
  };

  // Styled Tab
  const TabPanel = (props) => {
    const { children, value, index, px = 2, py = 1.5, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ px: px, py: py }}>{children}</Box>}
      </div>
    );
  };

  const a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
      color: theme.palette.warning.main,
    };
  };

  return (
    <Box
      sx={{
        width: "100%",
        mt: 2,
        border: `2px solid ${theme.palette.common.black}`,
      }}
      className="rounded"
    >
      <AppBar position="static">
        <Tabs
          value={valueTab}
          onChange={handleChangeTab}
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          sx={{
            backgroundColor: theme.palette.common.black,
            "& .MuiTabs-indicator": {
              fontSize: 5,
              backgroundColor: theme.palette.warning.main,
              height: 4,
            },
            "& .Mui-selected": {
              color: theme.palette.warning.light,
            },
          }}
        >
          <Tab
            label={t("Resolution.resolution")}
            {...a11yProps(0)}
            sx={{ fontSize: 14, fontWeight: 600 }}
            onClick={() =>
              setTimeout(() => {
                window.scrollTo({
                  top: document.documentElement.scrollHeight,
                  behavior: "smooth",
                });
              }, 100)
            }
          />
          <Tab
            label={t("Resolution.sanctions_actions")}
            {...a11yProps(1)}
            sx={{ fontSize: 14, fontWeight: 600 }}
            onClick={() =>
              setTimeout(() => {
                window.scrollTo({
                  top: document.documentElement.scrollHeight,
                  behavior: "smooth",
                });
              }, 100)
            }
          />
        </Tabs>
      </AppBar>

      <TabPanel value={valueTab} index={0} dir={theme.direction}>
        <Resolution reportDetail={reportDetail} reportRender={reportRender} />
      </TabPanel>

      <TabPanel value={valueTab} index={1} dir={theme.direction}>
        <SanctionsAndResolutions
          reportDetail={reportDetail}
          reportRender={reportRender}
          investigationList={investigationList}
          offenders={offenders}
          victims={victims}
          setActiveTab={setActiveTab}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      </TabPanel>
    </Box>
  );
};
